import React, { useMemo, useState } from 'react';
import { defineMessages } from 'react-intl';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import useFormField from '@hooks/useFormField';
import useTranslate from '@hooks/useTranslate';
import { commonMessage } from '@locales/intl';
import { IconSquareX } from '@tabler/icons-react';
import { Form, Upload } from 'antd';
import ImgCrop from 'antd-img-crop';
import classNames from 'classnames';

import styles from './index.module.scss';

const messages = defineMessages({
    required: '',
});
function CropImageField({
    label,
    fileList,
    disabled,
    name,
    valuePropName,
    accept,
    onChange,
    beforeUpload,
    showUploadList,
    aspect = 1,
    maxFile,
    imageUrl,
    loading,
    style,
    required,
    formItemProps,
    imgUploadedSizeAuto,
    handleRemoveImage,
    leftIconRemove = 68,
    styleUploadButton,
    isBanner = false,
    isNoCrop = false,
    ...props
}) {
    const translate = useTranslate();
    const { rules } = useFormField(props);
    const [ hoverItem, setHoverItem ] = useState(false);
    const updatedRules = useMemo(() => {
        if (required) {
            return [
                ...(rules || []),
                {
                    required: !imageUrl && !fileList?.length,
                    message: translate.formatMessage(messages.required),
                },
            ];
        }
        return rules;
    }, [ required, rules, label, imageUrl, fileList ]);

    const onUploadFile = ({ file }) => {
        const { uploadFile } = props;
        uploadFile(file);
    };

    const getContent = () => {
        if (imageUrl && !loading) {
            return (
                <div
                    style={{ margin: 4, maxWidth: '100%', ...styleUploadButton }}
                    onMouseMove={() => setHoverItem(true)}
                    onMouseLeave={() => setHoverItem(false)}
                    className={!isBanner && 'upload-wrapper'}
                >
                    <img
                        style={{ maxWidth: '100%', objectFit: 'contain', ...styleUploadButton }}
                        className={'img-uploaded'}
                        src={imageUrl}
                        alt="field-upload"
                    />
                    {/* {hoverItem && (
                        <IconSquareX
                            style={{
                                position: 'absolute',
                                top: 2,
                                left: leftIconRemove,
                                cursor: 'pointer',
                                color: 'white',
                                fill: 'red',
                                width: 30,
                                height: 30,
                            }}
                            onClick={(e) => {
                                e.stopPropagation();
                                handleRemoveImage();
                            }}
                            onMouseMove={() => setHoverItem(true)}
                            onMouseLeave={() => setHoverItem(false)}
                        />
                    )} */}
                </div>
            );
        } else if (showUploadList && fileList && fileList.length === maxFile) {
            return null;
        } else {
            return renderUploadButton();
        }
    };

    const renderUploadButton = () => {
        return (
            <div className="upload-wrapper" style={styleUploadButton}>
                {!showUploadList && loading ? <LoadingOutlined /> : <PlusOutlined />}
                {/* <div className="ant-upload-text">{loading ? 'uploading' : 'upload'}</div> */}
                <div className="ant-upload-text">{loading ? translate.formatMessage(commonMessage.uploading) : translate.formatMessage(commonMessage.upload)}</div>
            </div>
        );
    };

    const uploadClass = useMemo(() => {
        return [ 'avatar-uploader', imgUploadedSizeAuto && 'img-uploaded-size-auto' ].filter(Boolean).join(' ');
    }, []);

    return (
        <Form.Item
            {...formItemProps}
            required={required}
            label={label}
            name={name}
            rules={updatedRules}
            valuePropName={valuePropName}
        >
            {showUploadList ? (
                <ImgCrop aspect={aspect} fillColor="transparent" quality="1" modalProps={{ zIndex: 1000000 }}>
                    <Upload
                        fileList={fileList}
                        disabled={disabled}
                        accept={accept}
                        name="field-upload"
                        listType="picture-card"
                        style={{ width: '100%' }}
                        customRequest={onUploadFile}
                        beforeUpload={beforeUpload}
                        onChange={onChange}
                        className={uploadClass}
                    >
                        {getContent()}
                    </Upload>
                </ImgCrop>
            ) : isNoCrop ? (
                <Upload
                    disabled={disabled}
                    accept={accept}
                    valuePropName={valuePropName}
                    listType="picture-card"
                    style={{ width: '100%' }}
                    showUploadList={false}
                    customRequest={onUploadFile}
                    beforeUpload={beforeUpload}
                    onChange={onChange}
                    className={uploadClass}
                >
                    {getContent()}
                </Upload>
            ) : (
                <ImgCrop aspect={aspect} fillColor="transparent" quality="1" modalProps={{ zIndex: 1000000 }}>
                    <Upload
                        disabled={disabled}
                        accept={accept}
                        valuePropName={valuePropName}
                        listType="picture-card"
                        style={{ width: '100%' }}
                        showUploadList={false}
                        customRequest={onUploadFile}
                        beforeUpload={beforeUpload}
                        onChange={onChange}
                        className={uploadClass}
                    >
                        {getContent()}
                    </Upload>
                </ImgCrop>
            )}
        </Form.Item>
    );
}

export default CropImageField;
